import React, { useEffect } from 'react';

// Legal is canonical at groovie.live/privacy (single source of truth). This dashboard page
// used to carry its own divergent copy; it now redirects to the canonical page.
export default function Privacy() {
  useEffect(() => { window.location.replace('https://groovie.live/privacy'); }, []);
  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: 'rgba(255,255,255,0.55)', fontFamily: "'Outfit', -apple-system, sans-serif", fontSize: 14 }}>
      Redirecting to&nbsp;<a href="https://groovie.live/privacy" style={{ color: '#a855f7' }}>groovie.live/privacy</a>…
    </div>
  );
}
